const CampaignTypeEnum = {
    FREEPHOTO: "freephoto",
    QR: "qr",
    PQR: "pqr"
}

export default CampaignTypeEnum;